import Seo from '../../components/Seo';
import { useI18n } from '../../context/I18nContext';
import ServicesList from '../../components/services-page/ServicesList';
import Shortcuts from '../../components/services-page/Shortcuts';
import { absoluteUrl, getSiteUrl } from '../../lib/seo';

export default function ServicesPage() {
  const { language } = useI18n();
  const siteUrl = getSiteUrl();
  const title = language === 'fr' ? 'Services ETC Company' : 'ETC Company Services';
  const description =
    language === 'fr'
      ? 'Parcourez les services ETC Company pour l’accompagnement, la maintenance et la continuité opérationnelle.'
      : 'Explore ETC Company services for support, maintenance, and operational continuity.';
  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: language === 'fr' ? 'Accueil' : 'Home',
        item: absoluteUrl('/', siteUrl),
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: title,
        item: absoluteUrl('/services', siteUrl),
      },
    ],
  };

  return (
    <div key={language} className="bg-[var(--dash-blacker)]">
      <Seo
        title={title}
        description={description}
        jsonLd={[breadcrumbJsonLd]}
        keywords={{
          en: ['ETC Company services', 'after sales support', 'maintenance services', 'operational continuity', 'technical support'],
          fr: ['services ETC Company', 'support après vente', 'services de maintenance', 'continuité opérationnelle', 'support technique'],
        }}
      />
      <ServicesList />
      <Shortcuts />
    </div>
  );
}
